import moment from '@/moment-gp'
// import empty_timeslot_collection from '../empty_timeslot_collection';

export const VALID_COMMITMENT_TYPES = [ // --> SCHEMA
  'COMMITMENT_TEMPLATE',
  'COMMITMENT',
  'SEQUENCE_TYPE1',
  'SEQUENCE_TYPE2',
  'FIXED_TSC',
  'SPRINT'
];

export default {

  // TODO: there might be a problem, when this function is called twice and values were set to null by the user

  create({ user_id, type, goal_id }, data, BACKEND) {

    let commitment = {
      // ### Basic document management  {
      createdAt:      moment.currentTimeServer(BACKEND),
      createdBy:      user_id,
      picture:        data.picture || '', // - move to graphicalRepresentation?
      type:           type || 'COMMITMENT',
      // ### }

      // ### Graphical Representation {
      // INFO: moved to user setting
      // graphicalRepresentation: {},
      // ### }

      // ### essentian fields {
      // TODO: All except BACKLOG
      // parentGoalId:                 goal_id,                                 // DELETE
      startDate:                    data.startDate
                                    ? data.startDate.toBackend(BACKEND)
                                    : moment.currentDate().toBackend(BACKEND),
      endDate:                      data.endDate
                                    ? data.endDate.toBackend(BACKEND)
                                    : null,
      templateId:                   data.template_id || null,
      allowToEdit:                  true,
      commitmentCategoryId:         null, // NEU 20.02.2019 (organize commitments in categories)
      committedTime:                data.committedTime || 100 * 60 * 60,    // TODO !!! Move to TIME_BASED_TASKLIST
      committedTimeDaily:           data.committedTimeDaily || 1 * 60 * 60,   // 2 * 60 * 60, // OVERWRITE value for daily time commtiment
      recordedTime:                 data.recordedTime || 0 * 60,            // ???
      estimatedLastSessionEnd:      data.estimatedLastSessionEnd || null,   // when the last session will end (based on optimizer prediction, even without tasks)
      estimatedLastTaskEnd:         data.estimatedLastTaskEnd    || null    // when the last task will end (based on optimizer prediction, needs tasks)

      // ### }
    };

    Object.assign(
      commitment,
      this.additional_type_specific_fields(type, data)
    );

    return commitment;
  },

  additional_type_specific_fields(type, data) {
    switch (type) {

      case 'COMMITMENT_TEMPLATE':
      return {
        // ### if TYPE === 'COMMITMENT_TEMPLATE' {
        commitmentTemplateId:       data.commitmentTemplateId || null,
        dataFields:                 data.dataFields || {},
        sessionLength:              Number.parseInt(data.sessionLength) || 15 * 60,
        /* ... */
        maxSessionsPerDay:          Number.parseInt(data.maxSessionsPerDay) || -1,
        maxSessionsPerWeek:         Number.parseInt(data.maxSessionsPerWeek) || -1,
        // ### }
      }

      case 'COMMITMENT':
      return {
        // ### if TYPE === 'COMMITMENT' {
        commitmentOptionsSelected:  data.commitmentOptionsSelected || [ "investTime", "totalHours", "30H" ],
        // minSessionsPerDay:          data.minSessionsPerDay || 0,
        maxSessionsPerDay:          Number.parseInt(data.maxSessionsPerDay) || -1,
        sessionLength:              Number.parseInt(data.sessionLength) || 15 * 60,
        customAmount:               data.customAmount || 1,
        customFrequency:            data.customFrequency || 'perWeek',
        amountAchieved:             data.amountAchieved || 0, // ??
        finishedPercent:            0,
        // NEU 14.12.2018
        noSessionsAfterDeadline:    data.noSessionsAfterDeadline || false,
        // ### }
      }

      case 'SEQUENCE_TYPE1':
      return {
        // ### if TYPE === 'SEQUENCE_TYPE1' {
        sessionTemplateListType1:   data.sessionTemplateListType1 || [ /* sesion template items */ ],
        // ### }
      }

      case 'SEQUENCE_TYPE2':
      return {
        /* How many times should this sequence be repeated? */
        templateRepeat:             data.templateRepeat || 1,
        /* Id of the last item/session in the sequence, that was last finished. */
        lastCompletedSeqItemId:     data.lastCompletedSeqItemId || null,
        /* How many times has the sequence alreday been repeated? */
        completedSequences:         data.completedSequences || 0,
        /* Array of Sequence items. See empty_session_template_item */
        sessionTemplateListType2:   data.sessionTemplateListType2 || [ /* sesion template items */ ],
        // NEU 17.12.2018
        allowSessionToBeSkipped:    data.allowSessionToBeSkipped || false
      }

      case 'FIXED_TSC':
      return {
        // ### if TYPE === 'FIXED_TSC' {
        // Create TSC with empty_timeslot_collection('COMMITMENT') and assign Id
        // Meaning of the existing field:
        //  timeslotCollectionId => TSC is treated as this TSC (acts as parent)
        //  commitmentTscId      => TSC coupled with this commitment (acts as pair)
        commitmentTscId:            data.commitmentTscId || '',
        // ### }
      }

      case 'SPRINT':
      return {
        assignedTaskIds:  [ /* list of task id's */ ],
        cachedSumOfHours: 0,
        filter: {
          type: 'LANE', /* LANE, PRIO, USER */
          ref:  null    /* LaneId or UserId or minimum Prio */
        }
      }
      // NEU 22.02.2019
      case 'TASKLIST':
      return {
        /* Hours per day = Maximum time per day !*/
        committedTimePerDay:    data.committedTimePerDay || 1 * 60 * 60,
        // optional:
        /* Reference to sequence */
        schedulingSequence:     data.schedulingSequence || null,
        sessionLength:          Number.parseInt(data.sessionLength) || 15 * 60,
        // showFinished:     false, // INFO: moved to user setting
      }

      // NEU 22.02.2019
      case 'TIME_BASED_TASKLIST':
      return {
        /* Hours per day = Maximum time per day !*/
        committedTimePerDay:    data.committedTimePerDay || 1 * 60 * 60,
        sessionLength:          Number.parseInt(data.sessionLength) || 15 * 60,
      }

      case 'SEQUENCE':
      return {
        /* Reference to sequence */
        sequenceId:                 data.sequenceId || null,
        /* How many times should this sequence be repeated? */
        templateRepeat:             data.templateRepeat || 1,
        /* Id of the last item/session in the sequence, that was last finished. */
        lastCompletedSeqItemId:     data.lastCompletedSeqItemId || null,
        /* How many times has the sequence alreday been repeated? */
        completedSequences:         data.completedSequences || 0,
        /* Allows user to set option that missed sessions should not be resheduled (NEW 17.12.2018) */
        allowSessionToBeSkipped:    data.allowSessionToBeSkipped || false
      }

      case 'MAGICLIST':
      return {}

      case 'AMOUNT':
      return {
        amountType:                 data.amountType    || null, // 'OTHER',
        amountCurrent:              data.amountCurrent || 0,
        amountTarget:               data.amountTarget  || 1000,
      }

      case 'HABIT':
      return {
        habitNegation:               data.amountTarget || 'DO',
        habitRepeatPattern:          data.amountTarget || 'EVERY_DAY',
        habitRepeatDaily:            data.amountTarget || 1,
        habitWeekdays:               data.amountTarget || 'xxxxxxx',
      }

      case 'BACKLOG':
      return {}

      case 'TRELLO':
      return {}
    }
  },

  fields: {
    createdAt: { validate_bolt_type: 'ServerTimestamp' },
    createdBy: {},
    picture: {},
    // showFinished: {},
    /*
    graphicalRepresentation: {},
    graphicalRepresentation.fontFamily: {},
    graphicalRepresentation.fontSize: {},
    graphicalRepresentation.fill: {},
    graphicalRepresentation.show: {},
    */
    type: {},
    // parentGoalId: {},
    startDate: { validate_bolt_type: 'Timestamp' },
    endDate: { validate_bolt_type: 'Timestamp' },
    templateId: {},
    // timeslotCollectionId: {},
    allowToEdit: {},
    commitmentCategoryId: {},
    sequenceId: {},
    sessionLength: {},
    templateRepeat: {},
    lastCompletedSeqItemId: {},
    completedSequences: {},
    allowSessionToBeSkipped: {},
    committedTimeDaily: {},
    committedTimePerDay: {},
    schedulingSequence: {},
    recordedTime: {},
    committedTime: {},
    estimatedLastSessionEnd: {},
    estimatedLastTaskEnd: {},
    amountType: {},
    amountCurrent: {},
    amountTarget: {},
    habitNegation: {},
    habitRepeatPattern: {},
    habitRepeatDaily: {},
    habitWeekdays: {},
    // TODO ......
  }
};
